import React from 'react'
import { ConfigInfoProps } from '../../configLookup/components/Props';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from "@mui/material";
import styles from "../configInfo.module.css";

interface Props {
    config: ConfigInfoProps,
}

const ConfigAccordion:React.FC<Props> = ( {config} ) => {

  return (
    <div className={styles.configAcc}>
        <Accordion>
            <AccordionSummary
             expandIcon={<ExpandMoreIcon />}>
                <Typography variant='h6'>
                    <b>{config.configName}</b>
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography variant='body1'>
                    <b>Channel:</b> {config.channel}
                </Typography>
                <Typography variant='body1'>
                    <b>Subchannel:</b> {config.subChannel}
                </Typography>
            </AccordionDetails>

            <Accordion className={styles.subAcc}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}>
                    <b>Config Leads</b>
                </AccordionSummary>
                <AccordionDetails>
                    {config.configLeads.map((lead:any, idx:number) => (
                            <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}><b>Lead {idx}</b></AccordionSummary>
                            <AccordionDetails sx={{margin:.1}}>
                                <Divider/>
                                <p>Creation Phase Name: {lead.creationPhaseName}</p>
                                <p>Lead Type: {lead.leadType}</p>
                                <p>Lead ID: {lead.id}</p>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </AccordionDetails>
            </Accordion>

            <Accordion className={styles.subAcc}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}>
                    <b>Config Documents</b>
                </AccordionSummary>
                <AccordionDetails>
                    {config.configDocuments.map((doc: any) => <Typography>&#x2022; {doc.documentTitle} / {doc.fileName}</Typography>)}
                </AccordionDetails>
            </Accordion>

            <Accordion className={styles.subAcc}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}>
                    <b>Config Properties</b>
                </AccordionSummary>
                <AccordionDetails>
                    {config.configProperties.map((property:any, idx:number) => (
                            <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}><b>Property {idx}</b></AccordionSummary>
                            <AccordionDetails sx={{margin:.1}}>
                                <Divider/>
                                <p>Property Key: {property.propertyKey}</p>
                                <p>Property Value: {property.propertyValue}</p>
                                <p>ID: {property.id}</p>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </AccordionDetails>
            </Accordion>

            <Accordion className={styles.subAcc}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}>
                            <b>Phase Details</b>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Divider/>
                        <p>Card Processing Rate: {config.entityProperties.CardProcessingRate}</p>
                        <p>Per Transaction Charge: {config.entityProperties.CardProcessingPerTransactionCharge}</p>
                        <p>Header Title: {config.entityProperties.HeaderTitle}</p>
                        <p>Session Lifetime (Days): {config.entityProperties.SessionLifetimeInDays}</p>
                    </AccordionDetails>
                </Accordion>

        </Accordion>
    </div>
  )
}

export default ConfigAccordion